import { render, staticRenderFns } from "./TheFinanceDocuments.vue?vue&type=template&id=4c03952b&"
import script from "./TheFinanceDocuments.vue?vue&type=script&lang=js&"
export * from "./TheFinanceDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports